export default "__VITE_ASSET__3c3661d1__"